import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router"
import { getBranches } from "../../redux/branchSlice"

const SpecializationCategories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { branches, loading, error } = useSelector((state) => state.branches);

  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  // İstenen sıraya göre branch'leri sırala
  const preferredOrder = ["child", "adolescent", "adults", "couple"];
  const sortedBranches = [...(branches || [])].sort((a, b) => {
    const aIdx = preferredOrder.findIndex((key) =>
      a.name?.toLowerCase().includes(key)
    );
    const bIdx = preferredOrder.findIndex((key) =>
      b.name?.toLowerCase().includes(key)
    );
    const aRank = aIdx === -1 ? preferredOrder.length : aIdx;
    const bRank = bIdx === -1 ? preferredOrder.length : bIdx;
    return aRank - bRank;
  });
  const firstThreeBranches = sortedBranches.slice(0, 4);

  // Kart tıklama fonksiyonu
  const handleCardClick = (branch, index) => {
    navigate(`/experts?branch=${branch._id}&name=${encodeURIComponent(branch.name)}`);
  };

  // Yükleme durumunu kontrol et
  if (loading) {
    return (
      <div className="container mx-auto px-12 py-10">
        <div className="flex justify-center items-center">
          <p className="text-primary text-lg">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Hata durumunu kontrol et
  if (error) {
    return (
      <div className="container mx-auto px-12 py-10">
        <div className="flex justify-center items-center">
          <p className="text-red-500 text-lg">Hata: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-12 py-10">
      {/* Başlık */}
      <h2 className="text-primary text-[24px] sm:text-[28px] md:text-[32px] font-roboto leading-snug text-center mb-16">
        What type of therapy are you looking for?
      </h2>

      {/* Kartlar */}
      <div className="flex flex-wrap justify-center gap-y-6 gap-x-4 px-2 sm:px-6 md:px-12">
        {firstThreeBranches.map((branch, index) => (
          <div 
            key={branch._id} 
            className="relative w-full max-w-[200px] h-[180px] mx-auto bg-white border-[3px] border-cards-border rounded-[50px] shadow-lg overflow-hidden cursor-pointer hover:shadow-xl hover:scale-105 transition-all duration-300 ease-in-out"
            onClick={() => handleCardClick(branch, index)}
          >
            {/* Her kart için farklı resim */}
            {index === 0 && (
              <div className="relative w-[111px] h-[103px] bg-ice-cream bg-no-repeat bg-center bg-contain mx-auto mt-2"></div>
            )}
            {index === 1 && (
              <>
                <div className="absolute left-[18px] top-2 w-[79px] h-[73px] bg-doggie bg-no-repeat bg-center bg-contain"></div>
                <div className="absolute left-[82px] top-[27px] w-[79px] h-[73px] bg-petting bg-no-repeat bg-center bg-contain"></div>
              </>
            )}
            {index === 2 && (
              <div className="relative w-[123px] h-[113px] bg-unboxing bg-no-repeat bg-center bg-contain mx-auto my-0"></div>
            )}
            {index === 3 && (
              <div className="relative w-[111px] h-[103px] bg-swinging bg-no-repeat bg-center bg-contain mx-auto mt-2"></div>
            )}
            
            {/* Branch ismini göster */}
            <p className={`text-center text-text italic text-xl font-poppins ${index === 1 ? 'mt-[117px]' : 'mt-1'} ${index === 3 ? 'mt-2' : ''}`}>
              {branch.name}
            </p>
          </div>
        ))}
      </div>

      {/* Eğer 3'ten az branch varsa bilgi mesajı */}
      {firstThreeBranches.length < 4 && firstThreeBranches.length > 0 && (
        <div className="text-center mt-4">
          <p className="text-gray-500 text-sm">
            Toplam {firstThreeBranches.length} uzmanlık alanı gösteriliyor
          </p>
        </div>
      )}

      {/* Hiç branch yoksa mesaj */}
      {firstThreeBranches.length === 0 && (
        <div className="text-center mt-8">
          <p className="text-gray-500 text-lg">
            Henüz uzmanlık alanı bulunmamaktadır.
          </p>
        </div>
      )}
    </div>
  );
};

export default SpecializationCategories;
